import { render, staticRenderFns } from "./life-insurance.vue?vue&type=template&id=410817b4"
import script from "./life-insurance.vue?vue&type=script&lang=ts"
export * from "./life-insurance.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports